export default "__VITE_ASSET__ByDqKZWl__"